<template>
  <div class="tw-space-y-4">
    <slot />
  </div>
</template>
